import { render, staticRenderFns } from "./DLQI.vue?vue&type=template&id=0743ee04&"
import script from "./DLQI.vue?vue&type=script&lang=js&"
export * from "./DLQI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports